import { isRtlLanguage } from 'helpers/isRtlLanguage';

import { useSettings } from '@atlas/core';

export const useIsRtl = () => {
  const { lang } = useSettings();
  return isRtlLanguage({ lang });
};
